/**
 * Canonical list of telemetry event types. This is the single source of truth:
 * the `TelemetryEventType` union is derived from it, and consumers that need to
 * act on every event type (e.g. clearing every queued event) can iterate it
 * rather than hand-repeating the literals.
 */
export const telemetryEventTypes = ['Analytics', 'AnalyticsV2', 'Error', 'Info', 'Performance'] as const;

export type TelemetryEventType = (typeof telemetryEventTypes)[number];
